import IntersectionHydrator from '@mi/intersection-hydrator';
import { registrations } from '../registrations';
new IntersectionHydrator(registrations);
